import { Series } from '../series/chart-series';
import { ColumnBase } from './column-base';
import { Axis } from '../axis/axis';
import { markerShapes } from './marker';
import { getSeriesColor } from '../../common/model/theme';
/**
 * The `ParetoSeries` module is used to render the pareto series.
 */
export class ParetoSeries extends ColumnBase {
    constructor() {
        super(...arguments);
        this.paretoAxes = [];
    }
    /**
     * Defines the Line initialization.
     *
     * @private
     */
    initSeries(targetSeries, chart) {
        const series = new Series(chart, 'series', targetSeries.properties, true);
        const colors = chart.palettes.length ? chart.palettes : getSeriesColor(chart.theme);
        const count = colors.length;
        series.name = 'Pareto';
        series.yAxisName = targetSeries.yAxisName + '_CumulativeAxis';
        series.category = 'Pareto';
        targetSeries.category = 'Pareto';
        series.index = targetSeries.index + chart.series.length;
        series.type = 'Line';
        series.interior = series.fill = series.paretoOptions.fill ? series.paretoOptions.fill : colors[series.index % count];
        series.width = series.paretoOptions.width;
        series.dashArray = series.paretoOptions.dashArray;
        series.marker = series.paretoOptions.marker;
        if (series.marker && series.marker.visible) {
            series.marker.shape = series.marker.shape ? series.marker.shape : markerShapes[chart.markerIndex % 10];
            chart.markerIndex++;
        }
        chart.visibleSeries.push(series);
        this.initAxis(targetSeries, series, chart);
    }
    /**
     * Defines the Axis initialization for Line.
     *
     * @private
     */
    initAxis(paretoSeries, targetSeries, chart) {
        const isExist = this.paretoAxes.some((currentAxis) => {
            return currentAxis.name === targetSeries.yAxisName;
        });
        if (!isExist) {
            const secondaryAxis = (paretoSeries.yAxisName && chart.axes.length ? chart.axes.filter((axis) => {
                return axis.name === paretoSeries.yAxisName;
            })[0] : chart.primaryYAxis);
            const newAxis = new Axis(chart, 'axes', {
                name: targetSeries.yAxisName,
                majorGridLines: {
                    width: 0
                },
                majorTickLines: secondaryAxis.majorTickLines,
                lineStyle: secondaryAxis.lineStyle,
                minimum: 0,
                maximum: 100,
                interval: 20,
                rowIndex: secondaryAxis.rowIndex,
                opposedPosition: true,
                labelFormat: '{value}%'
            });
            this.paretoAxes.push(newAxis);
        }
    }
    /**
     * Render Pareto series.
     *
     * @returns {void}
     * @private
     */
    render(series) {
        series.chart.columnSeriesModule.render(series);
    }
    /**
     * Perform cumulative calculation on the provided JSON data based on the series type.
     *
     * @param {Object} json - The JSON data to perform cumulative calculation on.
     * @param {Series} series - The series for which cumulative calculation is performed.
     * @returns {Object[]} - An array containing the result of the cumulative calculation.
     * @private
     */
    performCumulativeCalculation(json, series) {
        const data = json;
        let sum = 0;
        let count = 0;
        const length = data.length;
        for (let i = 0; i < length; i++) {
            sum += data[i][series.yName];
        }
        for (let i = 0; i < length; i++) {
            count = count + data[i][series.yName];
            data[i][series.yName] = Number(((count / sum) * 100).toFixed(2));
        }
        return data;
    }
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */
    doAnimation(series) {
        this.animate(series);
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        return 'ParetoSeries';
        /**
         * return the module name.
         */
    }
    /**
     * To destroy the pareto series.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroy method performed here.
         */
    }
}
